import localeDe from './de';

export default {
  ...localeDe,
  'Aerodrome': 'Flughafen',
  'Aerodromes': 'Flughäfen',
  'Frequencies': 'Frequenzen',
}
